import { MESSAGES } from '../actionTypes';
import { getFCMNotification, brokerMessage, ordersMessage, exchangeMessages } from "../../apis/nontransactional";


// Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
export const updateMsgActiveChip = (payload) => {
    return { type: MESSAGES?.UPDATE_MSG_ACTIVE_CHIP, payload };
};
// Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End

// Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
export const updateStrExchangeNotification = (payload) => {
    return { type: MESSAGES?.UPDATE_STR_NOTIFCATION_EXCHANGE, payload };
};
// Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End

export const getMessages = (userId, groupId, userType, deviceType, siTemplate, recordCount) => async (dispatch) => {
    try {
        // Hari K : 26-09-2024 : message hub -passing payload 
        let resp = await getFCMNotification({ userId: userId, groupId: groupId, userType: userType, deviceType: deviceType, siTemplate: siTemplate, recordCount: recordCount });
        if (resp?.data?.result?.length > 0) {
            let brokerObj = resp?.data?.result?.map((each) => ({
                subject: each.MessageTitle,
                message: each.sMessage,
                sendMsgTime: each.MessageSendDateTime
            }));
            dispatch(MessagesBroker(brokerObj));
        }
        dispatch(Messages(resp?.data?.result));
    } catch (error) {
        dispatch(getMessagesFailure([]));
    }

};

export const getMessagesBroker = (objBroker) => async (dispatch) => {
    dispatch(getMessageBrokerSatus(true));
    try {
        let resp = await brokerMessage(objBroker);
        if (resp?.data?.result?.length > 0) {
            let brokerObj = resp?.data?.result?.map((each, id) => ({
                subject: each.Subject,
                message: each.Message,
                sendMsgTime: each.SendMsgTime
            }));
            dispatch(getMessageBrokerSatus(false));
            dispatch(MessagesBroker(brokerObj));
        } else {
            dispatch(getMessageBrokerSatus(false));
            dispatch(updateNotificationCountStatusSuccess(true));
            dispatch(getMessageBrokerFailure([]));    // Hari K : 07-11-2023 : SAT-109371 : Message Hub – even API get scuccess and having 0 items i am dispatching this to show zero state,it will make the isAPIFailed state true
        }
    } catch (error) {
        dispatch(getMessageBrokerSatus(false));
        dispatch(getMessageBrokerFailure([]));
    }

};

export const getMessagesOrders = (objOrders) => async (dispatch) => {
    dispatch(getMessageOrderStatus(true));
    try {
        let resp = await ordersMessage(objOrders);
        if (resp?.data?.result?.length > 0) {
            let ordersObj = resp.data.result.map((each, id) => ({
                orderId: each.cliOrdNo,
                msg: each.msg,
                date: each.date,
                time: each.time
            }));
            dispatch(getMessageOrderStatus(false));
            dispatch(updateNotificationCountStatusSuccess(false));
            dispatch(MessagesOrders(ordersObj, objOrders.pageNo));
        } else {
            dispatch(getMessageOrderStatus(false));
            dispatch(updateNotificationCountStatusSuccess(true));
            dispatch(getMessageOrderFailure([])); // Hari K : 07-11-2023 : SAT-109371 : Message Hub – even API get scuccess and having 0 items i am dispatching this to show zero state,it will make the isAPIFailed state true

        }
    } catch (error) {
        dispatch(getMessageOrderStatus(false));
        dispatch(getMessageOrderFailure([]));
    }

};

export const getMessagesNse = (objNse, allowedNewsCat) => async (dispatch) => {
    dispatch(getMessageNseStatus(true));
    try {
        let resp = await exchangeMessages(objNse, allowedNewsCat);
        if (resp?.data?.result?.length > 0) {
            let nseObj = resp.data.result.map((each, i) => ({
                msg: each.Messages,
                time: each.Time
            }));
            dispatch(getMessageNseStatus(false));
            dispatch(MessagesNse(nseObj));
        } else {
            dispatch(getMessageNseStatus(false));
            dispatch(updateNotificationCountStatusSuccess(true));
            dispatch(getMessageNseFailure([]));  // Hari K : 07-11-2023 : SAT-109371 : Message Hub – even API get scuccess and having 0 items i am dispatching this to show zero state,it will make the isAPIFailed state true
        }
    } catch (error) {
        dispatch(getMessageNseStatus(false));
        dispatch(getMessageNseFailure([]));
    }

};

// Hari K : 02-11-2023, BT-109371 message hub - added actions to update Notification status and to cleare the NSE state while changing drop down-start
export const updateNotificationsCountStatus = () => async (dispatch) => {
    dispatch(updateNotificationCountStatusSuccess(false));
};

export const clearNseState = () => async (dispatch) => {
    dispatch(clearNseStateSuccess());
};

export const clearNseStateSuccess = (payload) => {
    return { type: MESSAGES.CLEAR_NSE_STATE, payload };
};

// Hari K : 02-11-2023, BT-109371 message hub - added actions to update Notification status and to cleare the NSE state while changing drop down-end
export const Messages = (payload) => {
    return { type: MESSAGES.GET_MESSAGES, payload };
};

export const MessagesBroker = (broker) => {
    return { type: MESSAGES.GET_MESSAGES_BROKER, payload: broker };
};

export const MessagesOrders = (orders, orderPageNo) => {
    return { type: MESSAGES.GET_MESSAGES_ORDERS, payload: { orders, orderPageNo } }; /* Deepti B. 110050 Added page no. prop for order msg */
};

export const updateNotificationCountStatusSuccess = (payload) => {
    return { type: MESSAGES.UPDATE_NOTIFICATION_COUNT_STATUS, payload };
};

export const getMessageNseStatus = (payload) => {
    return { type: MESSAGES.GET_NSE_PENDING_STATUS, payload };
};
export const getMessageOrderStatus = (payload) => {
    return { type: MESSAGES.GET_ORDER_MESSAGE_STATUS, payload };
};
export const getMessageBrokerSatus = (payload) => {
    return { type: MESSAGES.GET_BROKER_MESSAGE_STATUS, payload };
};

export const MessagesNse = (nse) => {
    return { type: MESSAGES.GET_MESSAGES_NSE, payload: nse };
};

export const getMessagesFailure = (broker) => {
    return { type: MESSAGES.GET_MESSAGES_FAILURE, payload: broker };
};
export const getMessageBrokerFailure = (broker) => {
    return { type: MESSAGES.GET_MESSAGE_BROKER_FAILURE, payload: broker };
};
export const getMessageOrderFailure = (broker) => {
    return { type: MESSAGES.GET_MESSAGE_ORDER_FAILURE, payload: broker };
};
export const getMessageNseFailure = (broker) => {
    return { type: MESSAGES.GET_MESSAGE_NSE_FAILURE, payload: broker };
};

export const setNotifCountExchange = (payload) => {
    return { type: MESSAGES.SET_COUNT_EXCHANGE, payload: payload };
};
export const setNotifCountBroker = (payload) => {
    return { type: MESSAGES.SET_COUNT_BROKER, payload: payload };
};
export const setNotifCountOrder = (payload) => {
    return { type: MESSAGES.SET_COUNT_ORDER, payload: payload };
}




